<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-flex">
      <dark-Toggler class="d-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
      >
      
        <template #button-content>
          <div class="icons-div">
            <feather-icon
            :badge="statusAlertTmp"
            badge-classes="bg-danger"
            class="text-body"
            icon="WifiOffIcon"
            size="21"
            @click="redirectToAlertsHistory('status')"
          />
          <feather-icon
            :badge="countAlertTmp"
            badge-classes="bg-danger"
            class="text-body"
            icon="BellIcon"
            size="21"
            @click="redirectToAlertsHistory('users')"
          />

          </div>
          
        </template>
        
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.name || userData.username }}
            </p>
            <span class="user-status">{{userRoleSpanish }}</span>
          </div>
          <b-avatar
            size="40"
            :src="userData.avatar"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          >
            <feather-icon
              v-if="!userData.fullName"
              icon="UserIcon"
              size="22"
            />
          </b-avatar>
        </template>

        <b-dropdown-item
          :to="{ name: 'profile'}"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Perfil</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { avatarText } from '@core/utils/filter'
// import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import alertHistoryStoreModule from '../../views/alerts/history/alertHistoryStoreModule'
import allFetchData from '../../views/alerts/history/allFetchData'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const ALERT_HISTORY_APP_STORE_MODULE_NAME = 'alertHistory'

    // Register module
    if (!store.hasModule(ALERT_HISTORY_APP_STORE_MODULE_NAME)) store.registerModule(ALERT_HISTORY_APP_STORE_MODULE_NAME, alertHistoryStoreModule)

    const {
      fetchCountAlertActive,
      loading,
    } = allFetchData()

    return {
      fetchCountAlertActive,
      loading,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
      countAlertTmp: 0,
      statusAlertTmp: 0,
      valuesAlertTmp: 0,
      totalAlerts: 0,
    }
  },
  computed: {
    countAlertActive() {
      return this.$store.state.alertHistory.countAlertActive
    },

    userRoleSpanish() {
      const roleMap = {
        guest: 'Invitado',
        admin: 'Administrador',
        user: 'Usuario',
      };
      return roleMap[this.userData.role] || this.userData.role;
    },
  },
  watch: {
    countAlertActive() {
      if (this.countAlertActive !== this.countAlertTmp) {
        this.countAlertTmp = this.countAlertActive.valuesCount
        this.statusAlertTmp = this.countAlertActive.statusCount
        this.totalAlerts = this.countAlertActive.total
        this.$bvToast.toast(`Alertas activas: ${this.totalAlerts}`, {
          title: 'Alerta activa',
          variant: 'danger',
          autoHideDelay: 5000,
        })
      }
    },
  },
  mounted() {
    this.fetchCountAlertActive('', res => {
      this.$store.commit('alertHistory/SET_COUNT_ALERT_ACTIVE', res)
    })

    this.$socket.on('alerts', data => {
      this.$store.commit('alertHistory/SET_COUNT_ALERT_ACTIVE', (data.count + this.countAlertTmp))
    })
  },
  methods: {
    logout() {
      this.$router.push({ name: 'logout' })
    },
    redirectToAlertsHistory(type) {
      if (type === 'status') {
        // Set typeFilter to 'status'
        this.$router.push({ name: 'alerts-history', query: { type: 'status' } });
      } else if (type === 'users') {
        // Redirect to alerts-history without changing typeFilter
        this.$router.push({ name: 'alerts-history', query: { type: 'users' } });
      }
    }
  },
}
</script>
<style>
.icons-div{
  display: flex;
  gap: 2rem;
}
</style>
